module.exports = __webpack_public_path__ + "img/nav4.89d4ecd0.png";